import React from "react";
import "./Local_Connect_Intro.css";
import Gray_Btn from "../../common-components/common_btn/gray_btn/Gray_Btn";
import { useNavigate } from "react-router-dom";

const Local_Connect_Intro = () => {
  const navigate = useNavigate();

  return (
    <section className="local-connect-section">
      <div className="container">
        <div className="local-content">
          <h1 className="local-title">
            Welcome to <span>Loconex</span>
          </h1>

          <p className="local-description">
            Loconex is built to digitally organize your city. Instead of
            searching across multiple sources, citizens can find nearby shops,
            services, emergency contacts, government offices, and verified local
            people in seconds.
          </p>

          <p className="local-description">
            Whether you are a customer, a farmer, a business owner, or a
            resident needing support — Loconex brings your city closer to
            you.
          </p>

          <div className="btn_holder">
            <Gray_Btn
              btn_name="Register My Business"
              onClick={() => navigate("/become-seller")}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Local_Connect_Intro;
